__turbopack_context__.v({
  "checkbox": "checkbox-module-scss-module__h-8J1q__checkbox",
  "default": "checkbox-module-scss-module__h-8J1q__default",
  "disabled": "checkbox-module-scss-module__h-8J1q__disabled",
  "error": "checkbox-module-scss-module__h-8J1q__error",
});
